<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <h5>
        {{ headline }}
      </h5>
    </div>

    <div class="panel-body">
      <form @submit.prevent="$emit('submit', data)">
        <TextFormGroup
            v-model="data.name"
            name="name"
            label="Name"
            help-text="The name of the job region."
            :error="(errors.name || [])[0]"
        />

        <SubmitFormGroup button-class="btn-black"/>
      </form>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import SubmitFormGroup from '@/vendor/forms/FormGroups/Block/Submit'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'

export default {
  components: {SubmitFormGroup, TextFormGroup},

  props: {
    headline: {
      required: true,
      type: String
    },

    initial: {
      required: false,
      type: Object,
      default: () => ({})
    },

    errors: {
      required: true,
      type: Object
    }
  },

  data() {
    return {
      data: {...this.initial},

      shared: store
    }
  }
}
</script>
